export const TIER_BENEFIT_UPGRADE_CODE = 'LOYALTY_UPGRADE';

export const TIER_BENEFIT_UPGRADE_NAME = 'Ticket Upgrade';

export const TIER_BENEFIT_STATUS_USED = 'Used';
export const TIER_BENEFIT_STATUS_AVAILABLE = 'Available';
